import { ColumnViewModel } from '../../shared/column-types';

export const numDiseasesAssociatedToGene_SUMMARY: ColumnViewModel = {
  columns: [
    'diseaseName',
    'geneSymbol',
    'geneDescription',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'geneDPI',
    'geneDSI',
    'genepLI',
    'geneEnsemblIDs',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'disease_prevalence_class',
    'disease_prevalence_type',
    'disease_prevalence_geo_area',
    'disease_inheritance',
    'numCTs',
  ],
  defaultVisible: [
    'diseaseName',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'numCTs',
  ],
};
